import { Notification } from "element-ui";

const notifyModule = {
  error: (message, options) => notify("error", message, options),
  success: (message, options) => notify("success", message, options),
};

const notify = (type, message, options = {}) => {
  const notificationType = type || "success";
  const notificationMessage = message || notificationType;

  Notification({
    title: "",
    message: `<div class='flex flex-v-center'>
        <div class="icon ${notificationType} flex-v-stretch flex flex-v-center flex-h-center">
         <img src='/img/${notificationType}.svg' />
        </div>
        <div class='m-10 mr-40'>
        <p>${notificationMessage}</p>
        </div>
        <img src="/img/circle-x.svg" class="close"/>
        </div>`,
    dangerouslyUseHTMLString: true,
    offset: 200,
    ...options,
    duration: type === "error" ? 5000 : 4500,
  });
};

export default notifyModule;
